import { Typography } from "@material-ui/core";

export default function MessageError({ error = "" }) {
  return (
    <Typography style={{ fontWeight: 600, fontSize: "15px", color: "red", marginTop: "8px" }}>
      {error}
    </Typography>
  )
}
